/**
 * StoreRejectModal — reason picker for rejecting a store activation request.
 * Extracted from ManagePlatform.js
 */
import { XCircle, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

export default function StoreRejectModal({
  open,
  onOpenChange,
  selectedStore,
  storeRejectReasons,
  selectedRejectReason,
  setSelectedRejectReason,
  rejectReason,
  setRejectReason,
  onCancel,
  onConfirm,
  processingStore,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white"
        data-testid="store-reject-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <XCircle className="h-5 w-5 text-red-500" />
            رفض طلب المتجر
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <p className="text-[#808080]">
            سيتم رفض طلب المتجر: <span className="text-white font-medium">{selectedStore?.name}</span>
          </p>

          <div>
            <label className="text-sm text-[#808080] mb-2 block">سبب الرفض *</label>
            <select
              value={selectedRejectReason}
              onChange={(e) => setSelectedRejectReason(e.target.value)}
              className="w-full p-3 bg-[#0a0a0a] border border-[#2a2a4e] rounded-xl text-white focus:border-red-500 outline-none"
              data-testid="store-reject-reason-select"
            >
              <option value="">اختر سبب الرفض</option>
              {storeRejectReasons.map((reason) => (
                <option key={reason.id} value={reason.label_ar}>
                  {reason.label_ar}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm text-[#808080] mb-2 block">ملاحظات إضافية</label>
            <textarea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="أضف ملاحظات إضافية (اختياري)..."
              className="w-full h-24 bg-[#0a0a0a] border border-[#2a2a4e] rounded-xl p-3 text-white placeholder:text-[#606060] resize-none focus:border-red-500 focus:outline-none"
              data-testid="store-reject-notes"
            />
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#2a2a4e] text-white"
            data-testid="store-reject-cancel-btn"
          >
            إلغاء
          </Button>
          <Button
            onClick={onConfirm}
            disabled={!selectedRejectReason || processingStore === selectedStore?.id}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="store-reject-confirm-btn"
          >
            {processingStore === selectedStore?.id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <XCircle className="h-4 w-4 me-2" />
                تأكيد الرفض
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
